<template>
  <div class="moduleCont" v-title data-title="广东多对多物联集团股份有限公司">
    <!-- <div class="moduleTop_wrap">
      <div class="moduleTop container">
        <h1 class="title">共建·共享·共发展</h1>
        <div class="line"></div>
        <p>
          本着“优势互补、资源共享、跨界赋能、互惠双赢、共同发展”的原则,充分发挥合作优势,以数智科技助力医康养行业高质
          量发展,发挥为党和政府,为社会、群众、行业、企业科技服务的功能,为满足产业高质量、满足生活高品质贡献力量。
        </p>
        <div class="baner_list">
          <span
            class="xxxxxx"
            :class="acvieba == index ? 'xxxxxx-active' : ''"
            v-for="(item, index) in jiankangdata"
            :key="index"
            @click="jiankangdatabtn(index)"
            >{{ item }}</span
          >
        </div>
        <img
          v-show="acvieba == 0"
          style="width: 100%"
          src="../../assets/images/module/module002.jpg"
          alt=""
        />
        <img
          v-show="acvieba == 1"
          style="width: 100%"
          src="../../assets/images/module/module001.jpg"
          alt=""
        />
        <img
          v-show="acvieba == 2"
          style="width: 100%"
          src="../../assets/images/module/module003.jpg"
          alt=""
        />
      </div>
    </div>
    <div class="advantage">
      <img
        style="display: block; width: 100%"
        src="~img/module/module005.jpg"
        alt=""
      />
    </div> -->
    <div class="container">
      <img
        style="display: block; width: 100%"
        src="https://img.duoduiduo.com/gg/22/11/9ad70d74df104c6f8f304c544f45d277.jpg"
        alt=""
      />
    </div>

    <div class="bot-img">
      <img
        style="display: block; width: 100%"
        src="https://img.duoduiduo.com/gg/19/27/9668ba6bb22d46af94fa846426217af8.jpg"
        alt=""
      />
    </div>
    <!-- <div class="advantageList container">
			<ul class="listBox">
				<li><img src="~img/module/icon1.png" alt=""><br>信号强而稳定</li>
				<li><img src="~img/module/icon2.png" alt=""><br>信覆盖范围广</li>
				<li><img src="~img/module/icon3.png" alt=""><br>尺寸小</li>
				<li><img src="~img/module/icon4.png" alt=""><br>功耗低</li>
				<li><img src="~img/module/icon5.png" alt=""><br>接口丰富</li>
				<li><img src="~img/module/icon6.png" alt=""><br>可个性化对接</li>
			</ul>
			<div class="jrCont">
				<h3 class="title">多协议兼容，满足不同需求</h3>
				<div class="line"></div>
				<div class="jrBox">
					<ul class="line1">
						<li class="color1 none"></li>
						<li class="color2">红外</li>
						<li class="color3">蓝牙</li>
						<li class="color4 none"></li>
						<li class="null"></li>
					</ul>
					<ul class="line2">
						<li class="color5">Zigbee</li>
						<li class="color6">Wi-Fi</li>
						<li class="color7">433MHz无线</li>
						<li class="color8">Lora</li>
					</ul>
					<ul class="line3">
						<li class="null"></li>
						<li class="color9 none"></li>
						<li class="color10">2.4G射频</li>
						<li class="color11">ALLGO</li>
						<li class="color12 none"></li>
					</ul>
				</div>
			</div>
		</div> -->
  </div>
</template>

<script>
export default {
  name: "module",
  data() {
    return {
      jiankangdata: ["城市运营", "项目合作", "资源合作"],
      acvieba: 0,
    };
  },
  methods: {
    jiankangdatabtn(index) {
      this.acvieba = index;
    },
  },
  metaInfo: {
    meta: [
      {
        name: "keywords",
        content:
          "多对多物联集团、银发经济、人口老龄化、心脑血管、慢性疾病、血压高、血糖、体脂管理、中医馆、养生馆、健康管理师、科学工作站、公益行动、老年产品目录、健康机构、客户管理、拓客、医保社保、养生保健、远程管理",
      },
      {
        name: "discription",
        content:
          "多对多物联集团是一家深耕于大健康领域多年的健康管理数智服务商，是华为战略合作伙伴，华为健康数据与多对多实现互联互通。多对多健康管理 SaaS 系统和健康管理拓客赢利AI解决方案，为用户建立健康档案，提供健康 AI 管理。业务涵盖医院、养老机构、社区中心、康养中心、养老院、中医馆、养生馆等。针对人口老龄化现状和银发经济趋势，多对多加入了科学健康指导工作站，百城千镇家庭防大病数智服务健康公益行动办公室。开放专业健康管理师进驻，实现合作加盟共赢。",
      },
    ],
  },
};
</script>

<style scoped lang="less">
.line {
  height: 2px;
  width: 50px;
  background: #ee7b1d;
  margin: 20px auto;
}
.baner_list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  margin: 0 auto;
  margin-top: 40px;
  margin-bottom: 40px;
}
.xxxxxx {
  color: #ee7b1d;
  padding-top: 5px;
  padding-left: 100px;
  padding-right: 100px;
  font-weight: 600;
  font-size: 18px;
  padding-bottom: 8px;
  border: 1px solid rgba(75, 57, 57, 0.144);
  border-radius: 10px;
  cursor: pointer;
}
.xxxxxx-active {
  background-color: #ee7b1d;
  padding-left: 100px;
  padding-right: 100px;
  border: 1px solid rgba(75, 57, 57, 0.144);
  border-radius: 10px;
  color: #fff;
  // border-bottom: 2px solid #ee7b1d;
}
.moduleCont {
  box-shadow: 0 10px 10px -3px #ffeeee;
  padding: 8% 0;

  .moduleTop_wrap {
    box-shadow: 0 10px 10px -3px #ffeeee;
    .moduleTop {
      text-align: center;
      line-height: 30px;
      p {
        padding: 20px 0 20px;
        width: 850px;
        margin: 0 auto;
        @media (max-width: 576px) {
          width: 98%;
        }
      }
      .title {
        color: #ee7b1d;
      }
      .chose {
        height: 50px;
        // background: #663f3f;
        display: flex;
        justify-content: space-around;
        margin-bottom: 10px;
        div {
          padding: 1px 100px 1px 100px;
          margin: 3px;
          line-height: 50px;
          border: solid 0.5px rgb(85, 77, 77);
          border-radius: 0.5%;
          color: #ee7b1d;
          font-size: 16px;
          font-weight: 700;
          border-radius: 10px;
        }
      }
    }
  }
  .advantage {
    width: 80%;
    margin: auto;
  }
  .advantageList {
    ul.listBox {
      display: flex;
      justify-content: space-between;
      text-align: center;
      flex-wrap: wrap;
      padding: 60px 0;
      font-size: 16px;
      li {
        width: 300px;
        padding: 30px 0;
        line-height: 60px;
        border-radius: 5px;

        @media (max-width: 768px) {
          width: 44%;
        }

        @media (max-width: 576px) {
          width: 48%;
        }

        &:hover {
          box-shadow: #e1e1e1 0px 0px 10px;
        }
      }
    }

    .jrCont {
      .title {
        text-align: center;
        padding-top: 60px;
        font-size: 28px;
        color: #000;
        font-weight: bold;
      }

      .line {
        height: 2px;
        width: 50px;
        background: #ee7b1d;
        margin: 20px auto;
      }

      .jrBox {
        margin-top: 50px;

        ul {
          &.line2 {
            display: flex;
            justify-content: space-around;
            flex-wrap: wrap;

            @media (max-width: 768px) {
              justify-content: space-between;
            }
          }

          display: flex;
          justify-content: space-between;
          text-align: center;
          color: #fff;
          flex-wrap: wrap;

          li {
            width: 20%;
            font-size: 1.2rem;
            line-height: 55px;
            letter-spacing: 2px;
            border-radius: 6px;
            margin-bottom: 2rem;

            @media (max-width: 768px) {
              width: 40%;

              &.null,
              &.none {
                display: none;
              }

              font-size: 0.9rem;
            }

            @media (max-width: 576px) {
              width: 45%;
              font-size: 0.8rem;
              height: 3rem;
              line-height: 3rem;
            }

            &.null {
              width: 10%;
            }

            &.color1 {
              background-image: linear-gradient(90deg, #e9f3f9, #e9f3f9);
            }

            &.color2 {
              background-image: linear-gradient(90deg, #64cdfc, #00a1fb);
            }

            &.color3 {
              background-image: linear-gradient(90deg, #8477ed, #5a4ad6);
            }

            &.color4 {
              background-image: linear-gradient(90deg, #ebe8ff, #ebe8ff);
            }

            &.color5 {
              background-image: linear-gradient(90deg, #6495ed, #00f);
            }

            &.color6 {
              background: #ff8b5d;
            }

            &.color7 {
              background-image: linear-gradient(90deg, #50c187, #229e5f);
            }

            &.color8 {
              background-image: linear-gradient(90deg, #db7093, #c71585);
            }

            &.color9 {
              background: #fff2f1;
            }

            &.color10 {
              background-image: linear-gradient(90deg, #5f9afd, #2c73f3);
            }

            &.color11 {
              background-image: linear-gradient(90deg, #ff6f6f, #f93d3e);
            }

            &.color12 {
              background: #f4f0ff;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/module/module.vue